import { render } from "./About.vue?vue&type=template&id=2d5c7674"
const script = {}

import "./About.vue?vue&type=style&index=0&id=2d5c7674&lang=css"
script.render = render

export default script